// What a click on an order-list row does (order-list.screen navigateOrder),
// as a pure decision so the flag branches are testable without the screen's
// providers. Today (and with the flag off): workshop users open the
// price-stripped details view, hidden-price customers get NOTHING (the row
// click leads to /order/confirm, which shows prices), everyone else opens
// /order/confirm. Dead clicks round 2 (flag clarityUx2Enabled): the
// hidden-price case becomes a toast that says why - never a navigation
// (whether /order/details respects PriceVisibility is not verified).
export interface OrderRowClickContext {
  workshopMode: boolean;
  cartHidden: boolean;
  ux2: boolean;
}

export type OrderRowTarget =
  | { kind: "navigate"; to: string }
  | { kind: "toast" }
  | { kind: "none" };

export function resolveOrderRowTarget(
  order: { id: number | string; organization: { id: number | string } },
  ctx: OrderRowClickContext,
): OrderRowTarget {
  if (ctx.workshopMode) {
    return {
      kind: "navigate",
      to: `/order/details?orderId=${order.id}&orgId=${order.organization.id}`,
    };
  }
  if (ctx.cartHidden) {
    return ctx.ux2 ? { kind: "toast" } : { kind: "none" };
  }
  return {
    kind: "navigate",
    to: `/order/confirm?orderId=${order.id}&orgId=${order.organization.id}`,
  };
}

// The row opens the order on a click (ListItemFrame's handler) - and, with
// the flag on, on Enter/Space while the row itself has focus. Keys pressed
// on a button INSIDE the row (View, Pay now, the badge) are that button's
// own and must not open the order as well: only events whose target is the
// row count. `click()` re-uses the surrounding frame's click handler, so
// there is one code path for mouse and keyboard.
export function orderRowKeyDown(e: {
  key: string;
  target: EventTarget | null;
  currentTarget: EventTarget & { click: () => void };
  preventDefault: () => void;
}): void {
  if (e.target !== e.currentTarget) return;
  if (e.key !== "Enter" && e.key !== " ") return;
  e.preventDefault();
  e.currentTarget.click();
}
